import { MouseEventHandler } from 'react'

import { Box, Flex, SystemProps } from '@chakra-ui/react'

import { BrandColor } from 'src/types'

import InlineInfoIcon from '../../InlineInfoIcon/InlineInfoIcon'

const Button: React.FC<
  {
    brandColor: BrandColor
    showVideo: MouseEventHandler
    label?: string
  } & SystemProps
> = ({ brandColor, showVideo, label, ...props }) => (
  <Flex
    role="button"
    color={brandColor}
    alignItems="center"
    onClick={showVideo}
    {...props}
  >
    <InlineInfoIcon brandColor={brandColor} />
    {!!label && (
      <Box ml="6px" className="body-small-emphasis" lineHeight={1.4}>
        {label}
      </Box>
    )}
  </Flex>
)

export default Button
